import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "dash-topbar" }
const _hoisted_2 = { class: "dash-topbar-actions" }
const _hoisted_3 = { class: "dashboard-layout" }
const _hoisted_4 = { class: "dash-sidebar" }
const _hoisted_5 = { class: "dash-profile" }
const _hoisted_6 = { class: "dash-avatar" }
const _hoisted_7 = { class: "dash-name" }
const _hoisted_8 = { class: "dash-email" }
const _hoisted_9 = { class: "dash-nav" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "dash-main" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "dash-heading" }
const _hoisted_14 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_15 = { class: "dash-stats-row" }
const _hoisted_16 = { class: "dash-stat-card" }
const _hoisted_17 = { class: "dash-stat-value" }
const _hoisted_18 = { class: "dash-stat-card" }
const _hoisted_19 = {
  class: "dash-stat-icon",
  style: {"background":"rgba(25,135,84,0.15)"}
}
const _hoisted_20 = { class: "dash-stat-value text-capitalize" }
const _hoisted_21 = { class: "dash-stat-card" }
const _hoisted_22 = { class: "dash-stat-value" }
const _hoisted_23 = { class: "dash-stat-card" }
const _hoisted_24 = { class: "dash-stat-value" }
const _hoisted_25 = {
  key: 0,
  class: "dash-card mb-4"
}
const _hoisted_26 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_27 = { class: "dash-progress-track" }
const _hoisted_28 = { class: "d-flex justify-content-between mt-1" }
const _hoisted_29 = { class: "text-silver" }
const _hoisted_30 = { class: "text-silver" }
const _hoisted_31 = {
  key: 1,
  class: "dash-card text-center py-5"
}
const _hoisted_32 = {
  key: 2,
  class: "dash-card"
}
const _hoisted_33 = {
  key: 0,
  class: "dash-credential-row"
}
const _hoisted_34 = { class: "dash-credential-value" }
const _hoisted_35 = {
  key: 1,
  class: "dash-credential-row"
}
const _hoisted_36 = { class: "dash-credential-value" }
const _hoisted_37 = { class: "dash-credential-row" }
const _hoisted_38 = { class: "dash-credential-value" }
const _hoisted_39 = {
  key: 3,
  class: "dash-card text-center py-4"
}
const _hoisted_40 = { key: 1 }
const _hoisted_41 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_42 = { class: "dash-card mb-4" }
const _hoisted_43 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_44 = { style: {"color":"#fff","margin":"0"} }
const _hoisted_45 = { class: "dash-detail-row" }
const _hoisted_46 = { class: "dash-detail-row" }
const _hoisted_47 = { class: "dash-detail-row" }
const _hoisted_48 = { class: "dash-detail-row" }
const _hoisted_49 = {
  key: 0,
  class: "dash-detail-row"
}
const _hoisted_50 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_51 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_52 = { class: "text-silver" }
const _hoisted_53 = { class: "dash-progress-track" }
const _hoisted_54 = { class: "dash-card" }
const _hoisted_55 = {
  key: 2,
  class: "dash-card text-center py-5"
}
const _hoisted_56 = { key: 2 }
const _hoisted_57 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_58 = {
  key: 1,
  class: "dash-card text-center py-5"
}
const _hoisted_59 = { class: "dash-card" }
const _hoisted_60 = {
  key: 0,
  class: "dash-alert dash-alert-danger mb-3"
}
const _hoisted_61 = {
  key: 1,
  class: "dash-alert dash-alert-success mb-3"
}
const _hoisted_62 = {
  class: "d-flex gap-2 align-items-center",
  style: {"max-width":"480px"}
}
const _hoisted_63 = ["disabled"]
const _hoisted_64 = ["disabled"]
const _hoisted_65 = { class: "border-style" }
const _hoisted_66 = { class: "dash-card text-center py-4" }
const _hoisted_67 = { class: "dash-mac-display" }
const _hoisted_68 = {
  class: "text-silver mt-3",
  style: {"font-size":"0.82rem"}
}
const _hoisted_69 = { class: "dash-card" }
const _hoisted_70 = { class: "d-flex align-items-center gap-2 mb-4 flex-wrap" }
const _hoisted_71 = {
  key: 0,
  class: "text-silver ms-auto",
  style: {"font-size":"0.85rem"}
}
const _hoisted_72 = {
  key: 0,
  class: "dash-cred-block"
}
const _hoisted_73 = { class: "dash-cred-header" }
const _hoisted_74 = { class: "dash-cred-value" }
const _hoisted_75 = {
  key: 1,
  class: "dash-cred-block"
}
const _hoisted_76 = { class: "dash-cred-header" }
const _hoisted_77 = { class: "dash-cred-value" }
const _hoisted_78 = {
  key: 2,
  class: "dash-cred-block"
}
const _hoisted_79 = { class: "dash-cred-header" }
const _hoisted_80 = { class: "dash-cred-value" }
const _hoisted_81 = {
  key: 3,
  class: "dash-cred-block"
}
const _hoisted_82 = { class: "dash-cred-header" }
const _hoisted_83 = { class: "dash-cred-value" }
const _hoisted_84 = { class: "row g-3 mt-1" }
const _hoisted_85 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_86 = { class: "dash-cred-block" }
const _hoisted_87 = { class: "dash-cred-header" }
const _hoisted_88 = { class: "dash-cred-value" }
const _hoisted_89 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_90 = { class: "dash-cred-block" }
const _hoisted_91 = { class: "dash-cred-header" }
const _hoisted_92 = { class: "dash-cred-value" }
const _hoisted_93 = {
  key: 4,
  class: "dash-cred-block mt-1"
}
const _hoisted_94 = { class: "dash-cred-value" }
const _hoisted_95 = {
  key: 5,
  class: "dash-cred-block mt-1"
}
const _hoisted_96 = {
  class: "text-silver mb-0",
  style: {"padding":"0.75rem 1rem","font-size":"0.9rem"}
}
const _hoisted_97 = { key: 3 }
const _hoisted_98 = {
  key: 0,
  class: "dash-loading"
}
const _hoisted_99 = { class: "dash-card" }
const _hoisted_100 = {
  class: "text-silver mb-3",
  style: {"font-size":"0.92rem"}
}
const _hoisted_101 = { style: {"color":"#fff"} }
const _hoisted_102 = {
  class: "d-flex gap-2 align-items-center",
  style: {"max-width":"560px"}
}
const _hoisted_103 = ["value"]
const _hoisted_104 = { class: "border-style" }
const _hoisted_105 = {
  class: "text-silver mt-2",
  style: {"font-size":"0.82rem"}
}
const _hoisted_106 = { style: {"color":"#c90e0e"} }
const _hoisted_107 = { class: "dash-stats-row" }
const _hoisted_108 = { class: "dash-stat-card" }
const _hoisted_109 = { class: "dash-stat-value" }
const _hoisted_110 = { class: "dash-stat-card" }
const _hoisted_111 = { class: "dash-stat-value" }
const _hoisted_112 = { class: "dash-stat-card" }
const _hoisted_113 = { class: "dash-stat-value" }
const _hoisted_114 = { class: "dash-card" }
const _hoisted_115 = {
  class: "text-silver mb-0",
  style: {"font-size":"0.88rem"}
}
const _hoisted_116 = { key: 4 }
const _hoisted_117 = {
  key: 0,
  class: "dash-alert dash-alert-success mb-4"
}
const _hoisted_118 = {
  key: 1,
  class: "dash-alert dash-alert-danger mb-4"
}
const _hoisted_119 = { class: "dash-card mb-4" }
const _hoisted_120 = { class: "row g-3 mt-1" }
const _hoisted_121 = { class: "col-md-6" }
const _hoisted_122 = { class: "col-md-6" }
const _hoisted_123 = ["disabled"]
const _hoisted_124 = { class: "border-style" }
const _hoisted_125 = { class: "dash-card" }
const _hoisted_126 = { class: "row g-3 mt-1" }
const _hoisted_127 = { class: "col-md-4" }
const _hoisted_128 = { class: "col-md-4" }
const _hoisted_129 = ["disabled"]
const _hoisted_130 = { class: "border-style" }
const _hoisted_131 = { class: "dash-footer-copy" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "dash-topbar-brand" }, [
        _createElementVNode("i", { class: "ti ti-device-tv" }),
        _createTextVNode(" GoPlayTV ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          to: "/",
          class: "dash-topbar-link"
        }, {
          default: _withCtx(() => _cache[24] || (_cache[24] = [
            _createElementVNode("i", { class: "ti ti-world" }, null, -1),
            _createTextVNode(" View Site ")
          ])),
          _: 1
        }),
        _createElementVNode("button", {
          class: "dash-topbar-link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
        }, _cache[25] || (_cache[25] = [
          _createElementVNode("i", { class: "ti ti-logout" }, null, -1),
          _createTextVNode(" Logout ")
        ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("aside", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.initials), 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.authStore.user?.name), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.authStore.user?.email), 1)
          ])
        ]),
        _createElementVNode("nav", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createElementBlock("button", {
              key: tab.id,
              class: _normalizeClass(["dash-nav-item", { active: _ctx.activeTab === tab.id }]),
              onClick: ($event: any) => (_ctx.activeTab = tab.id)
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(tab.icon)
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(tab.label), 1)
            ], 10, _hoisted_10))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "dash-nav-item dash-logout mt-auto",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
        }, _cache[27] || (_cache[27] = [
          _createElementVNode("i", { class: "ti ti-logout" }, null, -1),
          _createTextVNode(" Logout ")
        ]))
      ]),
      _createElementVNode("main", _hoisted_11, [
        (_ctx.activeTab === 'overview')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("h2", _hoisted_13, "Welcome back, " + _toDisplayString(_ctx.authStore.user?.name), 1),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Loading your account..."))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _cache[29] || (_cache[29] = _createElementVNode("div", {
                          class: "dash-stat-icon",
                          style: {"background":"rgba(201,14,14,0.15)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ti ti-device-tv",
                            style: {"color":"#c90e0e"}
                          })
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.subscription ? _ctx.subscription.package?.name : 'None'), 1),
                          _cache[28] || (_cache[28] = _createElementVNode("div", { class: "dash-stat-label" }, "Current Plan", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("i", {
                            class: "ti ti-circle-check",
                            style: _normalizeStyle({ color: _ctx.subStatusColor })
                          }, null, 4)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.subscription?.status ?? 'No subscription'), 1),
                          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "dash-stat-label" }, "Status", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[32] || (_cache[32] = _createElementVNode("div", {
                          class: "dash-stat-icon",
                          style: {"background":"rgba(192,192,192,0.1)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ti ti-calendar-event",
                            style: {"color":"#c0c0c0"}
                          })
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.subscription?.expires_at ? _ctx.formatDate(_ctx.subscription.expires_at) : '—'), 1),
                          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "dash-stat-label" }, "Expires", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[34] || (_cache[34] = _createElementVNode("div", {
                          class: "dash-stat-icon",
                          style: {"background":"rgba(201,14,14,0.15)"}
                        }, [
                          _createElementVNode("i", {
                            class: "ti ti-wifi",
                            style: {"color":"#c90e0e"}
                          })
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.line ? 'Active' : 'Not assigned'), 1),
                          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "dash-stat-label" }, "IPTV Line", -1))
                        ])
                      ])
                    ]),
                    (_ctx.subscription?.expires_at)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _cache[35] || (_cache[35] = _createElementVNode("span", { class: "dash-card-label" }, "Subscription Time Remaining", -1)),
                            _createElementVNode("span", {
                              class: _normalizeClass(["dash-badge", _ctx.daysLeft > 7 ? 'badge-green' : 'badge-red'])
                            }, _toDisplayString(_ctx.daysLeft) + " days left", 3)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", {
                              class: "dash-progress-bar",
                              style: _normalizeStyle({ width: _ctx.progressPct + '%', background: _ctx.daysLeft > 7 ? '#198754' : '#c90e0e' })
                            }, null, 4)
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("small", _hoisted_29, _toDisplayString(_ctx.subscription.package?.name), 1),
                            _createElementVNode("small", _hoisted_30, _toDisplayString(_ctx.formatDate(_ctx.subscription.expires_at)), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.subscription)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _cache[37] || (_cache[37] = _createElementVNode("i", {
                            class: "ti ti-device-tv",
                            style: {"font-size":"3rem","color":"#c90e0e","display":"block","margin-bottom":"1rem"}
                          }, null, -1)),
                          _cache[38] || (_cache[38] = _createElementVNode("h4", { style: {"color":"#fff","margin-bottom":"0.5rem"} }, "You don't have an active subscription", -1)),
                          _cache[39] || (_cache[39] = _createElementVNode("p", { class: "text-silver mb-4" }, "Choose a plan to unlock your IPTV access", -1)),
                          _createVNode(_component_RouterLink, {
                            to: "/",
                            class: "btn"
                          }, {
                            default: _withCtx(() => _cache[36] || (_cache[36] = [
                              _createElementVNode("span", { class: "border-style" }, "View Plans", -1)
                            ])),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.line && _ctx.line.status !== 'pending_assignment')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _cache[44] || (_cache[44] = _createElementVNode("h5", { class: "dash-card-title" }, "IPTV Line", -1)),
                          (_ctx.line.portal_url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "dash-credential-label" }, "Portal URL", -1)),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("code", null, _toDisplayString(_ctx.line.portal_url), 1),
                                  _createElementVNode("button", {
                                    class: "dash-copy-btn",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copy(_ctx.line.portal_url, 'portal')))
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(_ctx.copied === 'portal' ? 'ti ti-check' : 'ti ti-copy')
                                    }, null, 2)
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!_ctx.line.portal_url || _ctx.line.m3u_url)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "dash-credential-label" }, "M3U URL", -1)),
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("code", null, _toDisplayString(_ctx.line.m3u_url || '—'), 1),
                                  (_ctx.line.m3u_url)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "dash-copy-btn",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copy(_ctx.line.m3u_url, 'm3u')))
                                      }, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(_ctx.copied === 'm3u' ? 'ti ti-check' : 'ti ti-copy')
                                        }, null, 2)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_37, [
                            _cache[42] || (_cache[42] = _createElementVNode("span", { class: "dash-credential-label" }, "EPG URL", -1)),
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("code", null, _toDisplayString(_ctx.line.epg_url || '—'), 1),
                              (_ctx.line.epg_url)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "dash-copy-btn",
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copy(_ctx.line.epg_url, 'epg')))
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass(_ctx.copied === 'epg' ? 'ti ti-check' : 'ti ti-copy')
                                    }, null, 2)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("button", {
                            class: "btn mt-3",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeTab = 'line'))
                          }, _cache[43] || (_cache[43] = [
                            _createElementVNode("span", { class: "border-style" }, "View Full Details", -1)
                          ]))
                        ]))
                      : (_ctx.line?.status === 'pending_assignment')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _cache[45] || (_cache[45] = [
                            _createElementVNode("i", {
                              class: "ti ti-loader-2",
                              style: {"font-size":"2rem","color":"#c90e0e","display":"block","margin-bottom":"0.5rem"}
                            }, null, -1),
                            _createElementVNode("p", { class: "text-silver mb-0" }, "Your IPTV line is being set up. We'll have your credentials ready shortly.", -1)
                          ])))
                        : _createCommentVNode("", true)
                  ], 64))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'subscription')
          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
              _cache[57] || (_cache[57] = _createElementVNode("h2", { class: "dash-heading" }, "My Subscription", -1)),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, "Loading..."))
                : (_ctx.subscription)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("h4", _hoisted_44, _toDisplayString(_ctx.subscription.package?.name), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["dash-badge", _ctx.subscription.status === 'active' ? 'badge-green' : 'badge-orange'])
                          }, _toDisplayString(_ctx.subscription.status), 3)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _cache[46] || (_cache[46] = _createElementVNode("span", null, "Price", -1)),
                          _createElementVNode("strong", null, "$" + _toDisplayString(_ctx.subscription.package?.price) + "/month", 1)
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          _cache[47] || (_cache[47] = _createElementVNode("span", null, "Duration", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.subscription.package?.duration_days) + " days", 1)
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _cache[48] || (_cache[48] = _createElementVNode("span", null, "Started", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatDate(_ctx.subscription.created_at)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _cache[49] || (_cache[49] = _createElementVNode("span", null, "Expires", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.subscription.expires_at ? _ctx.formatDate(_ctx.subscription.expires_at) : 'Never'), 1)
                        ]),
                        (_ctx.subscription.invoice_id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _cache[50] || (_cache[50] = _createElementVNode("span", null, "Invoice ID", -1)),
                              _createElementVNode("strong", null, _toDisplayString(_ctx.subscription.invoice_id), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.subscription.expires_at)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createElementVNode("div", _hoisted_51, [
                                _cache[51] || (_cache[51] = _createElementVNode("small", { class: "text-silver" }, "Time remaining", -1)),
                                _createElementVNode("small", _hoisted_52, _toDisplayString(_ctx.daysLeft) + " / " + _toDisplayString(_ctx.subscription.package?.duration_days) + " days", 1)
                              ]),
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("div", {
                                  class: "dash-progress-bar",
                                  style: _normalizeStyle({ width: _ctx.progressPct + '%', background: _ctx.daysLeft > 7 ? '#198754' : '#c90e0e' })
                                }, null, 4)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _cache[53] || (_cache[53] = _createElementVNode("h5", { class: "dash-card-title" }, "Upgrade or Renew", -1)),
                        _cache[54] || (_cache[54] = _createElementVNode("p", { class: "text-silver mb-3" }, "Want more features? Choose a different plan below.", -1)),
                        _createVNode(_component_RouterLink, {
                          to: "/",
                          class: "btn"
                        }, {
                          default: _withCtx(() => _cache[52] || (_cache[52] = [
                            _createElementVNode("span", { class: "border-style" }, "Browse Plans", -1)
                          ])),
                          _: 1
                        })
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _cache[56] || (_cache[56] = _createElementVNode("p", { class: "text-silver mb-3" }, "No active subscription.", -1)),
                      _createVNode(_component_RouterLink, {
                        to: "/",
                        class: "btn"
                      }, {
                        default: _withCtx(() => _cache[55] || (_cache[55] = [
                          _createElementVNode("span", { class: "border-style" }, "Browse Plans", -1)
                        ])),
                        _: 1
                      })
                    ]))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'line')
          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
              _cache[88] || (_cache[88] = _createElementVNode("h2", { class: "dash-heading" }, "My IPTV Line", -1)),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, "Loading..."))
                : (!_ctx.subscription)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _cache[59] || (_cache[59] = _createElementVNode("i", {
                        class: "ti ti-device-tv",
                        style: {"font-size":"3rem","color":"#c90e0e","display":"block","margin-bottom":"1rem"}
                      }, null, -1)),
                      _cache[60] || (_cache[60] = _createElementVNode("h4", { style: {"color":"#fff","margin-bottom":"0.5rem"} }, "No active subscription", -1)),
                      _cache[61] || (_cache[61] = _createElementVNode("p", { class: "text-silver mb-4" }, "Subscribe to a plan to get your IPTV line.", -1)),
                      _createVNode(_component_RouterLink, {
                        to: "/",
                        class: "btn"
                      }, {
                        default: _withCtx(() => _cache[58] || (_cache[58] = [
                          _createElementVNode("span", { class: "border-style" }, "Browse Plans", -1)
                        ])),
                        _: 1
                      })
                    ]))
                  : (!_ctx.line || !_ctx.line.mac_address)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _cache[63] || (_cache[63] = _createStaticVNode("<div class=\"dash-setup-steps\" data-v-1fb91010><div class=\"dash-step done\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010><i class=\"ti ti-check\" data-v-1fb91010></i></div><span data-v-1fb91010>Subscribed</span></div><div class=\"dash-step-line\" data-v-1fb91010></div><div class=\"dash-step active\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010>2</div><span data-v-1fb91010>Submit MAC</span></div><div class=\"dash-step-line\" data-v-1fb91010></div><div class=\"dash-step\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010>3</div><span data-v-1fb91010>Activation</span></div><div class=\"dash-step-line\" data-v-1fb91010></div><div class=\"dash-step\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010>4</div><span data-v-1fb91010>Watch</span></div></div><div class=\"dash-card\" data-v-1fb91010><h5 class=\"dash-card-title\" data-v-1fb91010>Step 1 — Download Your IPTV App</h5><p class=\"text-silver mb-3\" style=\"font-size:0.92rem;\" data-v-1fb91010>Install one of these apps on your device, then open it to find your MAC address or device key.</p><div class=\"dash-app-grid\" data-v-1fb91010><a href=\"https://iboplayer.com\" target=\"_blank\" rel=\"noopener\" class=\"dash-app-card\" data-v-1fb91010><i class=\"ti ti-player-play\" style=\"font-size:1.5rem;color:#c90e0e;\" data-v-1fb91010></i><div class=\"dash-app-name\" data-v-1fb91010>iboPlayer</div><div class=\"dash-app-platform\" data-v-1fb91010>Android / iOS / Smart TV</div></a><a href=\"https://tivimate.com\" target=\"_blank\" rel=\"noopener\" class=\"dash-app-card\" data-v-1fb91010><i class=\"ti ti-device-tv\" style=\"font-size:1.5rem;color:#c90e0e;\" data-v-1fb91010></i><div class=\"dash-app-name\" data-v-1fb91010>TiviMate</div><div class=\"dash-app-platform\" data-v-1fb91010>Android TV / Fire Stick</div></a><a href=\"https://www.smarters.pro\" target=\"_blank\" rel=\"noopener\" class=\"dash-app-card\" data-v-1fb91010><i class=\"ti ti-brand-android\" style=\"font-size:1.5rem;color:#c90e0e;\" data-v-1fb91010></i><div class=\"dash-app-name\" data-v-1fb91010>IPTV Smarters Pro</div><div class=\"dash-app-platform\" data-v-1fb91010>Android / iOS</div></a><a href=\"https://gse-smart-iptv.com\" target=\"_blank\" rel=\"noopener\" class=\"dash-app-card\" data-v-1fb91010><i class=\"ti ti-brand-apple\" style=\"font-size:1.5rem;color:#c90e0e;\" data-v-1fb91010></i><div class=\"dash-app-name\" data-v-1fb91010>GSE Smart IPTV</div><div class=\"dash-app-platform\" data-v-1fb91010>iOS / macOS</div></a></div></div>", 2)),
                        _createElementVNode("div", _hoisted_59, [
                          _cache[62] || (_cache[62] = _createStaticVNode("<h5 class=\"dash-card-title\" data-v-1fb91010>Step 2 — Submit Your MAC Address / Device Key</h5><p class=\"text-silver mb-3\" style=\"font-size:0.92rem;\" data-v-1fb91010> Open the app → go to <strong style=\"color:#fff;\" data-v-1fb91010>Settings</strong> → find <strong style=\"color:#fff;\" data-v-1fb91010>MAC Address</strong> or <strong style=\"color:#fff;\" data-v-1fb91010>Device Key</strong>. It usually looks like <code style=\"color:#c90e0e;\" data-v-1fb91010>AA:BB:CC:DD:EE:FF</code> or a alphanumeric key. </p>", 2)),
                          (_ctx.macError)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.macError), 1))
                            : _createCommentVNode("", true),
                          (_ctx.macSaved)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, "MAC address saved! We'll activate your line shortly."))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_62, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.macInput) = $event)),
                              type: "text",
                              class: "dash-input",
                              placeholder: "e.g. AA:BB:CC:DD:EE:FF",
                              disabled: _ctx.macSaving
                            }, null, 8, _hoisted_63), [
                              [_vModelText, _ctx.macInput]
                            ]),
                            _createElementVNode("button", {
                              class: "btn",
                              style: {"white-space":"nowrap"},
                              disabled: _ctx.macSaving || !_ctx.macInput.trim(),
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitMac && _ctx.submitMac(...args)))
                            }, [
                              _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.macSaving ? 'Saving...' : 'Submit'), 1)
                            ], 8, _hoisted_64)
                          ])
                        ])
                      ], 64))
                    : (_ctx.line.status === 'pending_assignment')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _cache[69] || (_cache[69] = _createStaticVNode("<div class=\"dash-setup-steps\" data-v-1fb91010><div class=\"dash-step done\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010><i class=\"ti ti-check\" data-v-1fb91010></i></div><span data-v-1fb91010>Subscribed</span></div><div class=\"dash-step-line done\" data-v-1fb91010></div><div class=\"dash-step done\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010><i class=\"ti ti-check\" data-v-1fb91010></i></div><span data-v-1fb91010>MAC Submitted</span></div><div class=\"dash-step-line\" data-v-1fb91010></div><div class=\"dash-step active\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010>3</div><span data-v-1fb91010>Activation</span></div><div class=\"dash-step-line\" data-v-1fb91010></div><div class=\"dash-step\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010>4</div><span data-v-1fb91010>Watch</span></div></div>", 1)),
                          _createElementVNode("div", _hoisted_66, [
                            _cache[66] || (_cache[66] = _createElementVNode("div", { style: {"font-size":"2.5rem","margin-bottom":"1rem"} }, "⏳", -1)),
                            _cache[67] || (_cache[67] = _createElementVNode("h4", { style: {"color":"#fff","margin-bottom":"0.5rem"} }, "Activation in Progress", -1)),
                            _cache[68] || (_cache[68] = _createElementVNode("p", { class: "text-silver mb-3" }, [
                              _createTextVNode("Your MAC address has been received. Our team is activating your line — this usually takes "),
                              _createElementVNode("strong", { style: {"color":"#fff"} }, "under 1 hour"),
                              _createTextVNode(".")
                            ], -1)),
                            _createElementVNode("div", _hoisted_67, [
                              _cache[64] || (_cache[64] = _createElementVNode("i", { class: "ti ti-device-desktop" }, null, -1)),
                              _createElementVNode("span", null, _toDisplayString(_ctx.line.mac_address), 1),
                              _createElementVNode("button", {
                                class: "dash-copy-btn",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.copy(_ctx.line.mac_address, 'mac')))
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(_ctx.copied === 'mac' ? 'ti ti-check' : 'ti ti-copy')
                                }, null, 2)
                              ])
                            ]),
                            _createElementVNode("p", _hoisted_68, [
                              _cache[65] || (_cache[65] = _createTextVNode("Need to change your MAC address? ")),
                              _createElementVNode("button", {
                                class: "dash-text-btn",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.line.mac_address = ''))
                              }, "Update it")
                            ])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _cache[87] || (_cache[87] = _createStaticVNode("<div class=\"dash-setup-steps\" data-v-1fb91010><div class=\"dash-step done\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010><i class=\"ti ti-check\" data-v-1fb91010></i></div><span data-v-1fb91010>Subscribed</span></div><div class=\"dash-step-line done\" data-v-1fb91010></div><div class=\"dash-step done\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010><i class=\"ti ti-check\" data-v-1fb91010></i></div><span data-v-1fb91010>MAC Submitted</span></div><div class=\"dash-step-line done\" data-v-1fb91010></div><div class=\"dash-step done\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010><i class=\"ti ti-check\" data-v-1fb91010></i></div><span data-v-1fb91010>Activated</span></div><div class=\"dash-step-line done\" data-v-1fb91010></div><div class=\"dash-step done\" data-v-1fb91010><div class=\"dash-step-num\" data-v-1fb91010><i class=\"ti ti-check\" data-v-1fb91010></i></div><span data-v-1fb91010>Watch</span></div></div>", 1)),
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _cache[71] || (_cache[71] = _createElementVNode("span", { style: {"color":"#4ade80","font-size":"1.3rem"} }, "●", -1)),
                              _cache[72] || (_cache[72] = _createElementVNode("h5", { class: "dash-card-title mb-0" }, "Your Line is Active", -1)),
                              (_ctx.line.expires_at)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_71, [
                                    _cache[70] || (_cache[70] = _createElementVNode("i", { class: "ti ti-calendar" }, null, -1)),
                                    _createTextVNode(" Expires " + _toDisplayString(_ctx.formatDate(_ctx.line.expires_at)), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.line.portal_url)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                  _createElementVNode("div", _hoisted_73, [
                                    _cache[73] || (_cache[73] = _createElementVNode("i", { class: "ti ti-device-desktop" }, null, -1)),
                                    _cache[74] || (_cache[74] = _createTextVNode(" Portal URL — enter this in your device / app ")),
                                    _createElementVNode("button", {
                                      class: "dash-copy-btn ms-auto",
                                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.copy(_ctx.line.portal_url, 'portal')))
                                    }, [
                                      _createElementVNode("i", {
                                        class: _normalizeClass(_ctx.copied === 'portal' ? 'ti ti-check' : 'ti ti-copy')
                                      }, null, 2),
                                      _createTextVNode(" " + _toDisplayString(_ctx.copied === 'portal' ? 'Copied!' : 'Copy'), 1)
                                    ])
                                  ]),
                                  _createElementVNode("code", _hoisted_74, _toDisplayString(_ctx.line.portal_url), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.line.server_url)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                  _createElementVNode("div", _hoisted_76, [
                                    _cache[75] || (_cache[75] = _createElementVNode("i", { class: "ti ti-server" }, null, -1)),
                                    _cache[76] || (_cache[76] = _createTextVNode(" Server URL ")),
                                    _createElementVNode("button", {
                                      class: "dash-copy-btn ms-auto",
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.copy(_ctx.line.server_url, 'srv')))
                                    }, [
                                      _createElementVNode("i", {
                                        class: _normalizeClass(_ctx.copied === 'srv' ? 'ti ti-check' : 'ti ti-copy')
                                      }, null, 2),
                                      _createTextVNode(" " + _toDisplayString(_ctx.copied === 'srv' ? 'Copied!' : 'Copy'), 1)
                                    ])
                                  ]),
                                  _createElementVNode("code", _hoisted_77, _toDisplayString(_ctx.line.server_url), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.line.m3u_url)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                  _createElementVNode("div", _hoisted_79, [
                                    _cache[77] || (_cache[77] = _createElementVNode("i", { class: "ti ti-list" }, null, -1)),
                                    _cache[78] || (_cache[78] = _createTextVNode(" M3U Playlist URL ")),
                                    _createElementVNode("button", {
                                      class: "dash-copy-btn ms-auto",
                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.copy(_ctx.line.m3u_url, 'm3u')))
                                    }, [
                                      _createElementVNode("i", {
                                        class: _normalizeClass(_ctx.copied === 'm3u' ? 'ti ti-check' : 'ti ti-copy')
                                      }, null, 2),
                                      _createTextVNode(" " + _toDisplayString(_ctx.copied === 'm3u' ? 'Copied!' : 'Copy'), 1)
                                    ])
                                  ]),
                                  _createElementVNode("code", _hoisted_80, _toDisplayString(_ctx.line.m3u_url), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.line.epg_url)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                  _createElementVNode("div", _hoisted_82, [
                                    _cache[79] || (_cache[79] = _createElementVNode("i", { class: "ti ti-calendar" }, null, -1)),
                                    _cache[80] || (_cache[80] = _createTextVNode(" EPG / Guide URL ")),
                                    _createElementVNode("button", {
                                      class: "dash-copy-btn ms-auto",
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.copy(_ctx.line.epg_url, 'epg')))
                                    }, [
                                      _createElementVNode("i", {
                                        class: _normalizeClass(_ctx.copied === 'epg' ? 'ti ti-check' : 'ti ti-copy')
                                      }, null, 2),
                                      _createTextVNode(" " + _toDisplayString(_ctx.copied === 'epg' ? 'Copied!' : 'Copy'), 1)
                                    ])
                                  ]),
                                  _createElementVNode("code", _hoisted_83, _toDisplayString(_ctx.line.epg_url), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_84, [
                              (_ctx.line.username)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                    _createElementVNode("div", _hoisted_86, [
                                      _createElementVNode("div", _hoisted_87, [
                                        _cache[81] || (_cache[81] = _createElementVNode("i", { class: "ti ti-user" }, null, -1)),
                                        _cache[82] || (_cache[82] = _createTextVNode(" Username ")),
                                        _createElementVNode("button", {
                                          class: "dash-copy-btn ms-auto",
                                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.copy(_ctx.line.username, 'user')))
                                        }, [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(_ctx.copied === 'user' ? 'ti ti-check' : 'ti ti-copy')
                                          }, null, 2)
                                        ])
                                      ]),
                                      _createElementVNode("code", _hoisted_88, _toDisplayString(_ctx.line.username), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.line.password)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                    _createElementVNode("div", _hoisted_90, [
                                      _createElementVNode("div", _hoisted_91, [
                                        _cache[83] || (_cache[83] = _createElementVNode("i", { class: "ti ti-lock" }, null, -1)),
                                        _cache[84] || (_cache[84] = _createTextVNode(" Password ")),
                                        _createElementVNode("button", {
                                          class: "dash-copy-btn ms-auto",
                                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.copy(_ctx.line.password, 'pass')))
                                        }, [
                                          _createElementVNode("i", {
                                            class: _normalizeClass(_ctx.copied === 'pass' ? 'ti ti-check' : 'ti ti-copy')
                                          }, null, 2)
                                        ])
                                      ]),
                                      _createElementVNode("code", _hoisted_92, _toDisplayString(_ctx.showPassword ? _ctx.line.password : '••••••••'), 1),
                                      _createElementVNode("button", {
                                        class: "dash-text-btn",
                                        style: {"padding":"0.25rem 1rem","display":"block"},
                                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                                      }, _toDisplayString(_ctx.showPassword ? 'Hide' : 'Show password'), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.line.mac_address)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                  _cache[85] || (_cache[85] = _createElementVNode("div", { class: "dash-cred-header" }, [
                                    _createElementVNode("i", { class: "ti ti-device-desktop" }),
                                    _createTextVNode(" Registered MAC Address")
                                  ], -1)),
                                  _createElementVNode("code", _hoisted_94, _toDisplayString(_ctx.line.mac_address), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.line.notes)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                  _cache[86] || (_cache[86] = _createElementVNode("div", { class: "dash-cred-header" }, [
                                    _createElementVNode("i", { class: "ti ti-notes" }),
                                    _createTextVNode(" Notes from Support")
                                  ], -1)),
                                  _createElementVNode("p", _hoisted_96, _toDisplayString(_ctx.line.notes), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 64))
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'refer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
              _cache[104] || (_cache[104] = _createElementVNode("h2", { class: "dash-heading" }, "Refer & Earn", -1)),
              (_ctx.referralLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_98, "Loading your referral details..."))
                : (_ctx.referral)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_99, [
                        _cache[92] || (_cache[92] = _createElementVNode("h5", { class: "dash-card-title" }, "Share your link, earn free days", -1)),
                        _createElementVNode("p", _hoisted_100, [
                          _cache[89] || (_cache[89] = _createTextVNode(" Invite friends with your personal link. When someone signs up and pays for their first subscription, you earn ")),
                          _createElementVNode("strong", _hoisted_101, _toDisplayString(_ctx.referral.reward_days) + " free days", 1),
                          _cache[90] || (_cache[90] = _createTextVNode(". "))
                        ]),
                        _cache[93] || (_cache[93] = _createElementVNode("label", { class: "dash-field-label" }, "Your referral link", -1)),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("input", {
                            value: _ctx.referralLink,
                            type: "text",
                            class: "dash-input",
                            readonly: ""
                          }, null, 8, _hoisted_103),
                          _createElementVNode("button", {
                            class: "btn",
                            style: {"white-space":"nowrap"},
                            onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.copyReferralLink && _ctx.copyReferralLink(...args)))
                          }, [
                            _createElementVNode("span", _hoisted_104, _toDisplayString(_ctx.referralCopied ? 'Copied!' : 'Copy'), 1)
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_105, [
                          _cache[91] || (_cache[91] = _createTextVNode(" Your code: ")),
                          _createElementVNode("code", _hoisted_106, _toDisplayString(_ctx.referral.code), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _cache[95] || (_cache[95] = _createElementVNode("div", {
                            class: "dash-stat-icon",
                            style: {"background":"rgba(96,165,250,0.15)"}
                          }, [
                            _createElementVNode("i", {
                              class: "ti ti-users",
                              style: {"color":"#60a5fa"}
                            })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_109, _toDisplayString(_ctx.referral.total_referred), 1),
                            _cache[94] || (_cache[94] = _createElementVNode("div", { class: "dash-stat-label" }, "People Referred", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_110, [
                          _cache[97] || (_cache[97] = _createElementVNode("div", {
                            class: "dash-stat-icon",
                            style: {"background":"rgba(74,222,128,0.15)"}
                          }, [
                            _createElementVNode("i", {
                              class: "ti ti-circle-check",
                              style: {"color":"#4ade80"}
                            })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.referral.qualified_count), 1),
                            _cache[96] || (_cache[96] = _createElementVNode("div", { class: "dash-stat-label" }, "Subscribed", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_112, [
                          _cache[99] || (_cache[99] = _createElementVNode("div", {
                            class: "dash-stat-icon",
                            style: {"background":"rgba(201,14,14,0.15)"}
                          }, [
                            _createElementVNode("i", {
                              class: "ti ti-gift",
                              style: {"color":"#c90e0e"}
                            })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.referral.earned_days), 1),
                            _cache[98] || (_cache[98] = _createElementVNode("div", { class: "dash-stat-label" }, "Free Days Earned", -1))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("p", _hoisted_115, [
                          _cache[101] || (_cache[101] = _createElementVNode("i", {
                            class: "ti ti-info-circle",
                            style: {"color":"#60a5fa"}
                          }, null, -1)),
                          _cache[102] || (_cache[102] = _createTextVNode(" Earned free days are applied by our team to your subscription. If you have days waiting, ")),
                          _createVNode(_component_RouterLink, {
                            to: "/contact-us",
                            style: {"color":"#c90e0e"}
                          }, {
                            default: _withCtx(() => _cache[100] || (_cache[100] = [
                              _createTextVNode("contact support")
                            ])),
                            _: 1
                          }),
                          _cache[103] || (_cache[103] = _createTextVNode(" to have them added to your line. "))
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeTab === 'profile')
          ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
              _cache[111] || (_cache[111] = _createElementVNode("h2", { class: "dash-heading" }, "My Profile", -1)),
              (_ctx.profileSaved)
                ? (_openBlock(), _createElementBlock("div", _hoisted_117, "Profile updated successfully."))
                : _createCommentVNode("", true),
              (_ctx.profileError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_118, _toDisplayString(_ctx.profileError), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_119, [
                _cache[107] || (_cache[107] = _createElementVNode("h5", { class: "dash-card-title" }, "Account Information", -1)),
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    _cache[105] || (_cache[105] = _createElementVNode("label", { class: "dash-field-label" }, "Full Name", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.profileForm.name) = $event)),
                      type: "text",
                      class: "dash-input"
                    }, null, 512), [
                      [_vModelText, _ctx.profileForm.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_122, [
                    _cache[106] || (_cache[106] = _createElementVNode("label", { class: "dash-field-label" }, "Email Address", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.profileForm.email) = $event)),
                      type: "email",
                      class: "dash-input"
                    }, null, 512), [
                      [_vModelText, _ctx.profileForm.email]
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn mt-4",
                  disabled: _ctx.profileSaving,
                  onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.saveProfile && _ctx.saveProfile(...args)))
                }, [
                  _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.profileSaving ? 'Saving...' : 'Save Changes'), 1)
                ], 8, _hoisted_123)
              ]),
              _createElementVNode("div", _hoisted_125, [
                _cache[110] || (_cache[110] = _createElementVNode("h5", { class: "dash-card-title" }, "Change Password", -1)),
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("div", _hoisted_127, [
                    _cache[108] || (_cache[108] = _createElementVNode("label", { class: "dash-field-label" }, "New Password", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.profileForm.password) = $event)),
                      type: "password",
                      class: "dash-input",
                      placeholder: "Min. 8 characters"
                    }, null, 512), [
                      [_vModelText, _ctx.profileForm.password]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_128, [
                    _cache[109] || (_cache[109] = _createElementVNode("label", { class: "dash-field-label" }, "Confirm Password", -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.profileForm.password_confirmation) = $event)),
                      type: "password",
                      class: "dash-input",
                      placeholder: "Repeat password"
                    }, null, 512), [
                      [_vModelText, _ctx.profileForm.password_confirmation]
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  class: "btn mt-4",
                  disabled: _ctx.profileSaving,
                  onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.saveProfile && _ctx.saveProfile(...args)))
                }, [
                  _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.profileSaving ? 'Saving...' : 'Update Password'), 1)
                ], 8, _hoisted_129)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_131, " © " + _toDisplayString(new Date().getFullYear()) + " GoPlayTV. All rights reserved. ", 1)
  ], 64))
}